export interface FeatureFlagsState {
  activeFeatures: string[];
  dataSpaceId: number | null;
  loading: boolean;
  loaded: boolean;
  error: string | null;
}

export const initialFeatureFlagsState: FeatureFlagsState = {
  activeFeatures: [],
  dataSpaceId: null,
  loading: false,
  loaded: false,
  error: null
};
